













































































































import Vue from 'vue';
import { state } from '@/store';
import syncStateWithStorage from '@/mixins/sync-state-with-storage';
import CategoryAutoComplete from '@/components/CategoryAutoComplete.vue';
import MODELS from '../../constants/models';
import {
  handleErrors, showSavedNotification,
} from '@/utils/notifications';
import { createTranslation } from '@/utils/graphqlMethods';
import { getEventIsSubmitForm } from '@/utils/eventShortcuts';
import displayEnterTip from '@/utils/displayEnterTip';
import client from '@/client';

interface FieldType {
  value: string,
  languageId: string,
  text: string,
  label: string,
}

export default Vue.extend({
  name: 'AddAssets',

  components: { CategoryAutoComplete },

  mixins: [syncStateWithStorage(['displayFields'])],

  props: {
    value: { type: Boolean, required: false, default: true },
  },

  data() {
    return {
      asset: MODELS.asset,
      // Copy from fieldOptions
      displayFields: state.project.languages.map(language => ({
        value: `language.${language.id}`,
        languageId: language.id,
        text: `${language.code}`,
        label: `${language.code} ${this.$t('translate.translation')}`,
      })),
      addNewAssetOnSubmit: true,
      displaySettings: false,
      displayModal: false,
    };
  },

  computed: {
    filteredDisplayFields(): FieldType[] {
      const fieldValues: string[] = this.displayFields.map(({value}) => value);
      return this.fieldOptions.filter(({value}) => fieldValues.includes(value));
    },

    fieldOptions(): FieldType[] {
      return state.project.languages.map(language => ({
        value: `language.${language.id}`,
        languageId: language.id,
        text: `${language.code}`,
        label: `${language.code} ${this.$t('translate.translation')}`,
      }));
    },

    hasValue(): boolean {
      return this.displayFields
        .map(({ value }) => this.asset[value])
        .filter(v => !!v)
        .length > 0 || this.asset.value;
    },
  },

  mounted() {
    this.displayModal = true;
  },

  methods: {
    imageForLanguage(languageId) {
      try {
        return state.project.languages.find(({ id }) => id === languageId).imageUrl
      } catch (e) {
        return null;
      }
    },

    handleTextAreaKeyPress(event) {
      displayEnterTip();
      if (getEventIsSubmitForm(event)) {
        this.submit()
      }
    },

    async submit() {
      if(!this.hasValue) {
        return;
      }

      const { ok, asset } = await client.createAsset({
        project: state.project.id,
        value: this.asset.value,
        description: this.asset.description,
      });

      if (!(ok && asset && asset.id)) {
        handleErrors("We couldn't save your new asset. Please make sure the Asset ID is unique within your project!");
        return;
      }

      this.displayFields.forEach(({languageId, value}) => {
        if (languageId && this.asset[value]) {
          const formatted = this.asset[value].replace("\n", " ")
          createTranslation(asset.id, languageId, formatted);
        }
      });

      showSavedNotification();
      this.setNewAssetToState();

      if (this.addNewAssetOnSubmit) {
      } else {
        this.close();
      }
    },

    close() {
      this.displayModal = false;
      setTimeout(() => {
        this.$emit('input', false);
      }, 250);
    },

    setNewAssetToState() {
      Object.keys(this.asset).forEach((key) => {
        this.asset[key] = MODELS.asset[key];
      });
    }
  },
});
